export default from './ResetPasswordForm';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/ResetPassword/components/ResetPasswordForm/index.js